import React from 'react'

export const IconSearch = (props = {}) => {
	const {size = 16, imgSize= 16, fill = "white"} = props
	return <>
		<svg xmlns="http://www.w3.org/2000/svg"
				 width={`${size}px`}
				 height={`${size}px`}
				 viewBox={`0 0 ${imgSize} ${imgSize}`}
				 fill="none"
		>
			<path fillRule="evenodd" clipRule="evenodd"
						d="M7.33286 2.48002C4.65244 2.48002 2.47953 4.65293 2.47953 7.33335C2.47953 10.0138 4.65244 12.1867 7.33286 12.1867C10.0133 12.1867 12.1862 10.0138 12.1862 7.33335C12.1862 4.65293 10.0133 2.48002 7.33286 2.48002ZM1.51953 7.33335C1.51953 4.12274 4.12225 1.52002 7.33286 1.52002C10.5435 1.52002 13.1462 4.12274 13.1462 7.33335C13.1462 8.76586 12.6281 10.0774 11.769 11.0906L14.6784 14L13.9995 14.6788L11.0902 11.7695C10.0769 12.6286 8.76537 13.1467 7.33286 13.1467C4.12225 13.1467 1.51953 10.544 1.51953 7.33335Z"
						fill={fill} fillOpacity="0.6"
			/>
		</svg>
	</>
}
